__turbopack_context__.v({
  "section": "AnalyzerCommentsSection-module-scss-module__Fz4rDa__section",
  "sectionTitle": "AnalyzerCommentsSection-module-scss-module__Fz4rDa__sectionTitle",
});
